import {
    createSlice
} from "@reduxjs/toolkit";
import {
    showNotification
} from "./notificationSlice";
import {
    factory
} from "../../api/apiFactory";

const rolesApi = factory.get("roles");

const initialState = {
    roles_list: {
        loading: false,
        data: []
    },
}

export const rolesSlice = createSlice({
    name: "roles",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state[action.payload].loading = !state[action.payload].loading;
        },
        setRoles: (state, {
            payload
        }) => {
            state.roles_list.data = payload
        },
    }
})

export const {
    setRoles,
    setLoading
} = rolesSlice.actions

export default rolesSlice.reducer;

//axios 
export const Roles = {
    list: (data) => async (dispatch) => {
        try {
            dispatch(setLoading('roles_list'));
            const res = await rolesApi.getRolesList()
            dispatch(setRoles(res.data.data));
            dispatch(setLoading('roles_list'));
        } catch (err) {
            dispatch(setLoading('roles_list'));
            throw new Error(err);
        }
    },
    assign: (data) => async (dispatch) => {
        try {
            const res = await rolesApi.assignRole(data)
            dispatch(showNotification({
                message: res.data.message,
                type: "success"
            }));
        } catch (err) {
            dispatch(showNotification({
                message: err.response.data.errors[0],
                type: "error"
            }));
            throw new Error(err);
        }
    }


}